export default __webpack_public_path__ + "static/media/reward-6.cb10e471.png";